import { handleActions } from 'redux-actions';

const initialState = {
  messages: [],
  messageType: '',
};

const flash = handleActions(
  {
    ADD_MESSAGE: (state, action) => {
      if (state.messages.indexOf(action.payload.flashMessage) < 0) {
        return {
          ...state,
          messages: state.messages.concat(action.payload.flashMessage),
          messageType: action.payload.messageType,
        };
      }
      return state;
    },
    CLEAR_MESSAGE: () => initialState,
    AUTHENTICATION_LOGOUT: () => ({
      ...initialState,
    }),
  },
  initialState,
);

export default flash;



// WEBPACK FOOTER //
// ./src/store/reducers/Flash/index.js